var exports = {
  "kL": "container__uVWEBp",
  "u9": "accessibleHeader__g0LStH",
  "lE": "mention__LppmWE",
  "G5": "command__EUEEpg",
  "DV": "codeBlock__VnMx-4",
};

module.exports = exports;
